/**
 * Wellnove — force chaque ajout au panier à créer une nouvelle ligne séparée.
 * Mécanisme : injection d'une propriété cachée `_added_at` (timestamp unique)
 * dans toute requête /cart/add. Shopify regroupe par variant + properties → si
 * la propriété diffère, le line item est séparé.
 *
 * IMPORTANT : pour les requêtes /cart/add avec items[] (multi-add), on utilise
 * UN SEUL `_added_at` partagé pour tous les items du batch. Cela évite que la
 * modal "Quick add" (qui peut envoyer 1 item dans un items[]) ne soit
 * artificiellement éclaté en plusieurs lignes.
 */
(function () {
  const ENDPOINT = '/cart/add';

  function uniqueId() {
    return Date.now().toString() + Math.floor(Math.random() * 1e6).toString();
  }

  function injectIntoFormData(fd) {
    if (!(fd instanceof FormData)) return fd;
    fd.set('properties[_added_at]', uniqueId());
    return fd;
  }

  function injectIntoJson(body) {
    try {
      const obj = typeof body === 'string' ? JSON.parse(body) : body;
      const id = uniqueId();
      if (Array.isArray(obj.items)) {
        // Same _added_at for the whole batch (avoids splitting bundle/multi-add)
        obj.items = obj.items.map(function (it) {
          it.properties = it.properties || {};
          it.properties._added_at = id;
          return it;
        });
      } else {
        obj.properties = obj.properties || {};
        obj.properties._added_at = id;
      }
      return JSON.stringify(obj);
    } catch (e) {
      return body;
    }
  }

  function isAddUrl(url) {
    if (!url) return false;
    const s = typeof url === 'string' ? url : (url.url || '');
    return s.indexOf(ENDPOINT) !== -1;
  }

  // Intercept fetch
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isAddUrl(url) && init && init.body) {
        if (init.body instanceof FormData) {
          init.body = injectIntoFormData(init.body);
        } else if (typeof init.body === 'string') {
          init.body = injectIntoJson(init.body);
        }
      }
    } catch (e) {}
    return origFetch.apply(this, arguments);
  };

  // Intercept XHR
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__wn_url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (isAddUrl(this.__wn_url) && body) {
      if (body instanceof FormData) body = injectIntoFormData(body);
      else if (typeof body === 'string') body = injectIntoJson(body);
    }
    return origSend.call(this, body);
  };

  // Inject hidden input on classic form submissions to /cart/add
  document.addEventListener('submit', function (ev) {
    const form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    const action = (form.action || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;
    let inp = form.querySelector('input[name="properties[_added_at]"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[_added_at]';
      form.appendChild(inp);
    }
    inp.value = uniqueId();
  }, true);
})();
